var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "v-list-tile",
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "" }
              })
            ],
            1
          )
        : _c(
            "v-list-tile",
            {
              attrs: { avatar: "" },
              on: {
                click: function($event) {
                  return _vm.showSentences()
                }
              }
            },
            [
              _c(
                "v-list-tile-avatar",
                [
                  _vm.biblio.subs
                    ? _c("v-icon", { staticClass: "primary white--text" }, [
                        _vm._v("collections_bookmark")
                      ])
                    : _c("v-icon", { staticClass: "primary white--text" }, [
                        _vm._v("book")
                      ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [_vm._v(_vm._s(_vm.biblio.title))]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$tc("sentences", _vm.biblio.sentences.length, {
                            count: _vm.biblio.sentences.length
                          })
                        ) +
                        "\n        "
                    ),
                    _vm._v(" "),
                    _vm.biblio.subs
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("and")) +
                              "\n          " +
                              _vm._s(
                                _vm.$tc(
                                  "subLibraries",
                                  _vm.biblio.subs.length,
                                  { count: _vm.biblio.subs.length }
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.biblio.id != 0
                ? _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-menu",
                        { attrs: { bottom: "", left: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { slot: "activator", icon: "icon" },
                              nativeOn: {
                                mouseover: function($event) {
                                  _vm.overMenu = true
                                },
                                mouseleave: function($event) {
                                  _vm.overMenu = false
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("more_vert")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-tile",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.openDialogUpdate()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("cap")(_vm.$t("edit"))
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.$tc(
                                                _vm.biblio.subs
                                                  ? "libraries"
                                                  : "subLibraries",
                                                1,
                                                { count: "" }
                                              )
                                            )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.openDialogDelete()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("cap")(_vm.$t("delete"))
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.$tc(
                                                _vm.biblio.subs
                                                  ? "libraries"
                                                  : "subLibraries",
                                                1,
                                                { count: "" }
                                              )
                                            )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.showDialogUpdate,
            callback: function($$v) {
              _vm.showDialogUpdate = $$v
            },
            expression: "showDialogUpdate"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(
                  _vm._s(_vm._f("cap")(_vm.$t("edit"))) +
                    " " +
                    _vm._s(
                      _vm.$tc(
                        _vm.biblio.subs ? "libraries" : "subLibraries",
                        1,
                        { count: "" }
                      )
                    )
                )
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:32",
                        expression: "'required|max:32'"
                      }
                    ],
                    attrs: {
                      label: _vm._f("cap")(
                        _vm.$t("edit") +
                          " " +
                          _vm.$tc("subLibraries", 1, { count: "" })
                      ),
                      max: "32",
                      required: "",
                      "data-vv-name": "biblioInput",
                      error: _vm.wzErrors.has("biblioInput"),
                      errors: _vm.wzErrors.collect("biblioInput")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitDialogUpdate.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.biblioDialog.title,
                      callback: function($$v) {
                        _vm.$set(_vm.biblioDialog, "title", $$v)
                      },
                      expression: "biblioDialog.title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogUpdate = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", disabled: _vm.wzErrors.any() },
                      on: { click: _vm.submitDialogUpdate }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.showDialogDelete,
            callback: function($$v) {
              _vm.showDialogDelete = $$v
            },
            expression: "showDialogDelete"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(
                  _vm._s(_vm._f("cap")(_vm.$t("delete"))) +
                    " " +
                    _vm._s(
                      _vm.$tc(
                        _vm.biblio.subs ? "libraries" : "subLibraries",
                        1,
                        { count: "" }
                      )
                    ) +
                    "?"
                )
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("askRemoveLibrary")) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogDelete = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitDialogDelete()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("yes")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eef74eb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eef74eb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzBiblio.vue
// module id = null
// module chunks = 